import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  isBizzcalcRoute = false;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isBizzcalcRoute = event.urlAfterRedirects.startsWith('/main/bizzcalc');
      }
    });
  }

  ngOnInit(): void {
    this.isBizzcalcRoute = this.router.url.startsWith('/main/bizzcalc');
  }
}
